import React from 'react';
import { motion } from 'framer-motion';
import { LayoutGrid, Zap, Heart, TrendingUp } from 'lucide-react';
const benefits = [{
  title: 'Tranquilidad Mental',
  description: 'Deja de vivir con incertidumbre y entiende exactamente cuál es tu situación financiera.',
  icon: Heart,
  color: 'bg-rose-50 text-rose-600'
}, {
  title: 'Ahorro Real',
  description: 'Detecta gastos innecesarios y encuentra oportunidades para comenzar a ahorrar.',
  icon: TrendingUp,
  color: 'bg-teal-50 text-teal-600'
}, {
  title: 'Sin Complicaciones',
  description: 'No necesitas conocimientos avanzados. Orden Financiero™ está diseñado para ser simple y práctico.',
  icon: Zap,
  color: 'bg-amber-50 text-amber-600'
}, {
  title: 'Todo en un Solo Lugar',
  description: 'Ingresos, gastos, deudas, objetivos y ahorros organizados dentro del mismo sistema.',
  icon: LayoutGrid,
  color: 'bg-blue-50 text-blue-600'
}];
export function Benefits() {
  return <section className="py-10 md:py-20 bg-gray-50" data-id="element-14" data-mp="2q507v85bb2i">
      <div className="container mx-auto px-4 md:px-6" data-id="element-15" data-mp="6st6pw9e05wb">
        <div className="text-center mb-6 md:mb-12" data-id="element-16" data-mp="6tkvan4kh3d3">
          <h2 className="font-display text-2xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-2 md:mb-4" data-id="element-17" data-mp="3oynzm5mplbcg">
            Más que una plantilla: claridad para tu vida financiera
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-18" data-mp="lhxrnl7kgo84">
            Porque ordenar tus finanzas va mucho más allá de registrar números.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-19" data-mp="brw20ozkexr3">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-3 md:p-6 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow" data-id="element-20" data-mp="gqfnkoa8y7ix" data-mpi={index}>
              <div className={`w-8 h-8 md:w-12 md:h-12 ${benefit.color} rounded-xl flex items-center justify-center mb-2 md:mb-4`} data-id="element-21" data-mp="193rjgbmsdyi8">
                <benefit.icon className="w-4 h-4 md:w-6 md:h-6" data-id="element-22" data-mp="104wf753ayyhk" />
              </div>
              <h3 className="text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2" data-id="element-23" data-mp="vdo6ycdplj5z">
                {benefit.title}
              </h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed" data-id="element-24" data-mp="qfmmpo4jrdsx">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}